export const PERMISSION_OPTIONS = [
  { key: 'viewReports', label: 'Ver reportes y dashboard' },
  { key: 'manageClients', label: 'Gestionar clientes' },
  { key: 'manageInvoices', label: 'Gestionar ventas' },
  { key: 'manageExpenses', label: 'Gestionar egresos' },
  { key: 'exportData', label: 'Exportar datos' },
];

const DEFAULT_BY_ROLE = {
  viewer: {
    viewReports: true,
    manageClients: false,
    manageInvoices: false,
    manageExpenses: false,
    exportData: false,
  },
  employee: {
    viewReports: true,
    manageClients: true,
    manageInvoices: true,
    manageExpenses: true,
    exportData: false,
  },
  admin: {
    viewReports: true,
    manageClients: true,
    manageInvoices: true,
    manageExpenses: true,
    exportData: true,
  },
};

function hasFullAccess(user) {
  if (!user) return false;
  if (user.isSuperAdmin && user.role === 'admin') return true;
  if (user.role === 'company_owner') return true;
  if (user.ownedCompanies?.length > 0) return true;
  if (user.permissions?.all) return true;
  if (user.role === 'employee') return false;
  const activeEmployment = (user.employeeOf || []).some((e) => e.isActive !== false);
  if (activeEmployment) return false;
  if (user.currentPlan || user.role === 'user') return true;
  return false;
}

export function permissionsForRole(companyRole) {
  const role = ['viewer', 'admin'].includes(companyRole) ? companyRole : 'employee';
  return { ...(DEFAULT_BY_ROLE[role] || DEFAULT_BY_ROLE.employee) };
}

export function resolveUserPermissions(user) {
  if (!user) return {};
  if (user.permissions && typeof user.permissions === 'object') {
    return user.permissions;
  }
  const entry = user.employeeOf?.find((e) => e.isActive !== false) || user.employeeOf?.[0];
  if (!entry) return hasFullAccess(user) ? permissionsForRole('admin') : {};
  const custom = entry.permissions || {};
  return { ...permissionsForRole(entry.role), ...custom };
}

export function hasPermission(user, permission) {
  if (hasFullAccess(user)) return true;
  const perms = resolveUserPermissions(user);
  return !!perms[permission];
}

export function togglePermission(current, key, value) {
  return { ...current, [key]: value };
}
